var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoconnection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2722_11488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.47357 5.95947H1.97567C2.59667 5.93657 2.59673 5.04491 1.97567 5.02197H1.47357C0.852605 5.04488 0.852512 5.93654 1.47357 5.95947Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5264 10.043H14.0244C13.4034 10.0659 13.4033 10.9575 14.0244 10.9805H14.5264C15.1474 10.9575 15.1475 10.0659 14.5264 10.043Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.49023 2.44492C5.74911 2.44492 5.95898 2.23504 5.95898 1.97617V1.47407C5.93608 0.853074 5.04442 0.853012 5.02148 1.47407V1.97617C5.02148 2.23504 5.23133 2.44492 5.49023 2.44492Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5117 13.5571C10.2528 13.5571 10.043 13.767 10.043 14.0259V14.528C10.0659 15.1489 10.9575 15.149 10.9805 14.528V14.0259C10.9805 13.767 10.7706 13.5571 10.5117 13.5571Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.67278 3.33625C3.12753 3.75984 3.75893 3.13025 3.33668 2.67431L2.98272 2.31928C2.528 1.89572 1.89653 2.52519 2.31881 2.98122L2.67278 3.33625Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3265 12.666C12.8717 12.2424 12.2403 12.8719 12.6626 13.3279L13.0165 13.6829C13.4713 14.1065 14.1027 13.477 13.6804 13.021L13.3265 12.666Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.6808 12.9006C1.56898 12.7889 1.46486 12.6715 1.36845 12.5493L0.137297 13.7805C-0.0457656 13.9636 -0.0457656 14.2603 0.137297 14.4434L1.5578 15.8639C1.74086 16.047 2.03764 16.047 2.2207 15.8639L3.45142 14.6332C3.19723 14.4543 1.93111 13.1386 1.6808 12.9006Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.08984 6.65181L6.51 8.07191L7.26813 7.314C7.65806 6.92397 7.66241 6.28822 7.26809 5.89378C6.87684 5.5025 6.23928 5.50178 5.84697 5.89416L5.08984 6.65181Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1079 8.73363C9.71662 8.34234 9.07906 8.34162 8.68675 8.734L7.92969 9.49156L9.34984 10.9117L10.1079 10.1538C10.4978 9.76378 10.5022 9.12806 10.1079 8.73363Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.07025 6.95956C3.88729 6.77663 3.59069 6.77647 3.40763 6.95928L2.34313 8.02444C1.17657 9.18959 1.17804 11.0743 2.34307 12.238L3.7615 13.6582C4.92413 14.8193 6.81488 14.8181 7.97691 13.6575C7.97691 13.6575 9.04047 12.5933 9.0406 12.5931C9.22375 12.4103 9.22404 12.1131 9.04088 11.9299L4.07025 6.95956Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.863 1.55877L14.4425 0.138273C14.2594 -0.0447891 13.9626 -0.0447891 13.7795 0.138273L12.5488 1.36899C12.6711 1.46518 12.7885 1.56902 12.9002 1.68062C13.144 1.93727 14.4461 3.19352 14.6318 3.45284L15.863 2.22168C16.046 2.03862 16.046 1.74184 15.863 1.55877Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6553 7.97769C14.822 6.81241 14.8203 4.92769 13.6553 3.76416L12.2369 2.34404C11.0749 1.18341 9.18418 1.18338 8.02155 2.34466C8.02155 2.34466 6.95799 3.40888 6.95783 3.409C6.77468 3.59188 6.77436 3.88903 6.95755 4.07222L11.9281 9.0426C12.1111 9.22554 12.4077 9.22566 12.5908 9.04288L13.6553 7.97769Z",
    fill: ""
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2722_11488"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "",
    transform: "translate(0 0.000976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoconnection);
export default __webpack_public_path__ + "static/media/noconnection.5dcf76b2540b4381286879999ca2bf95.svg";
export { ForwardRef as ReactComponent };